import request from '@/utils/request'

export function getViewerProfile(viewer_id) {
  return request({
      url: `/profiles/${viewer_id}`,
      method: 'get',
  })
}